import {
  DOCUMENT,
  SIGN_OUT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function document(state = initialState, action) {
  switch (action.type) {
    case DOCUMENT.handlers.fetch:
    case DOCUMENT.handlers.update:
    case DOCUMENT.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case DOCUMENT.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
